module.exports = __webpack_public_path__ + "media/images/logo_onelife-82235383.png";